var $g5Y9E$mitt = require("mitt");

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

$parcel$export(module.exports, "VideoEventFilter", () => $fcdb6cf3608c4662$exports.VideoEventFilter);
$parcel$export(module.exports, "PlayerEvents", () => $fcdb6cf3608c4662$exports.PlayerEvents);
$parcel$export(module.exports, "PlayerState", () => $fcdb6cf3608c4662$exports.PlayerState);
var $fcdb6cf3608c4662$exports = {};

$parcel$export($fcdb6cf3608c4662$exports, "PlayerState", () => $fcdb6cf3608c4662$export$e3425b961a6a8509, (v) => $fcdb6cf3608c4662$export$e3425b961a6a8509 = v);
$parcel$export($fcdb6cf3608c4662$exports, "PlayerEvents", () => $fcdb6cf3608c4662$export$5013cbcdb4d9878b, (v) => $fcdb6cf3608c4662$export$5013cbcdb4d9878b = v);
$parcel$export($fcdb6cf3608c4662$exports, "VideoEventFilter", () => $fcdb6cf3608c4662$export$68ce463a75cf738d, (v) => $fcdb6cf3608c4662$export$68ce463a75cf738d = v);

var $516c8d13080d4552$export$691d3e4b1045a188 = function() {
    function $516c8d13080d4552$export$691d3e4b1045a188() {
        this.emitter = ($parcel$interopDefault($g5Y9E$mitt))();
    }
    $516c8d13080d4552$export$691d3e4b1045a188.prototype.addEventListener = function(event, handler) {
        this.emitter.on.apply(this, [
            event,
            handler
        ]);
    };
    $516c8d13080d4552$export$691d3e4b1045a188.prototype.removeEventListener = function(event, handler) {
        if (this.emitter) this.emitter.off.apply(this, [
            event,
            handler
        ]);
    };
    $516c8d13080d4552$export$691d3e4b1045a188.prototype.clear = function() {
        this.emitter.all.clear();
    };
    $516c8d13080d4552$export$691d3e4b1045a188.prototype.emit = function(event, data) {
        if (this.emitter) this.emitter.emit.apply(this, [
            event,
            data
        ]);
    };
    $516c8d13080d4552$export$691d3e4b1045a188.prototype.destroy = function() {
        this.emitter.all.clear();
        this.emitter = null;
    };
    return $516c8d13080d4552$export$691d3e4b1045a188;
}();


var $fcdb6cf3608c4662$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d1, b1) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d1, b1);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $fcdb6cf3608c4662$export$e3425b961a6a8509;
(function($fcdb6cf3608c4662$export$e3425b961a6a8509) {
    $fcdb6cf3608c4662$export$e3425b961a6a8509["Idle"] = "idle";
    $fcdb6cf3608c4662$export$e3425b961a6a8509["Loading"] = "loading";
    $fcdb6cf3608c4662$export$e3425b961a6a8509["Playing"] = "playing";
    $fcdb6cf3608c4662$export$e3425b961a6a8509["Paused"] = "paused";
    $fcdb6cf3608c4662$export$e3425b961a6a8509["Buffering"] = "buffering";
    $fcdb6cf3608c4662$export$e3425b961a6a8509["Seeking"] = "seeking";
    $fcdb6cf3608c4662$export$e3425b961a6a8509["Ended"] = "ended";
})($fcdb6cf3608c4662$export$e3425b961a6a8509 || ($fcdb6cf3608c4662$export$e3425b961a6a8509 = {
}));
var $fcdb6cf3608c4662$export$5013cbcdb4d9878b;
(function($fcdb6cf3608c4662$export$5013cbcdb4d9878b) {
    $fcdb6cf3608c4662$export$5013cbcdb4d9878b["Loading"] = "loading";
    $fcdb6cf3608c4662$export$5013cbcdb4d9878b["Loaded"] = "loaded";
    $fcdb6cf3608c4662$export$5013cbcdb4d9878b["Play"] = "play";
    $fcdb6cf3608c4662$export$5013cbcdb4d9878b["Resume"] = "resume";
    $fcdb6cf3608c4662$export$5013cbcdb4d9878b["Pause"] = "pause";
    $fcdb6cf3608c4662$export$5013cbcdb4d9878b["Seeking"] = "seeking";
    $fcdb6cf3608c4662$export$5013cbcdb4d9878b["Seeked"] = "seeked";
    $fcdb6cf3608c4662$export$5013cbcdb4d9878b["Buffering"] = "buffering";
    $fcdb6cf3608c4662$export$5013cbcdb4d9878b["Buffered"] = "buffered";
    $fcdb6cf3608c4662$export$5013cbcdb4d9878b["TimeUpdate"] = "timeupdate";
    $fcdb6cf3608c4662$export$5013cbcdb4d9878b["Ended"] = "ended";
    $fcdb6cf3608c4662$export$5013cbcdb4d9878b["Error"] = "error";
})($fcdb6cf3608c4662$export$5013cbcdb4d9878b || ($fcdb6cf3608c4662$export$5013cbcdb4d9878b = {
}));
var $fcdb6cf3608c4662$var$NetworkState;
(function(NetworkState) {
    NetworkState[NetworkState["NETWORK_EMPTY"] = 0] = "NETWORK_EMPTY";
    NetworkState[NetworkState["NETWORK_IDLE"] = 1] = "NETWORK_IDLE";
    NetworkState[NetworkState["NETWORK_LOADING"] = 2] = "NETWORK_LOADING";
    NetworkState[NetworkState["NETWORK_NO_SOURCE"] = 3] = "NETWORK_NO_SOURCE";
})($fcdb6cf3608c4662$var$NetworkState || ($fcdb6cf3608c4662$var$NetworkState = {
}));
var $fcdb6cf3608c4662$var$ReadyState;
(function(ReadyState) {
    ReadyState[ReadyState["HAVE_NOTHING"] = 0] = "HAVE_NOTHING";
    ReadyState[ReadyState["HAVE_METADATA"] = 1] = "HAVE_METADATA";
    ReadyState[ReadyState["HAVE_CURRENT_DATA"] = 2] = "HAVE_CURRENT_DATA";
    ReadyState[ReadyState["HAVE_FUTURE_DATA"] = 3] = "HAVE_FUTURE_DATA";
    ReadyState[ReadyState["HAVE_ENOUGH_DATA"] = 4] = "HAVE_ENOUGH_DATA";
})($fcdb6cf3608c4662$var$ReadyState || ($fcdb6cf3608c4662$var$ReadyState = {
}));
function $fcdb6cf3608c4662$var$getInitialState(videoElement) {
    if (videoElement.readyState === $fcdb6cf3608c4662$var$ReadyState.HAVE_NOTHING && videoElement.networkState === $fcdb6cf3608c4662$var$NetworkState.NETWORK_EMPTY) return $fcdb6cf3608c4662$export$e3425b961a6a8509.Idle;
    else if (videoElement.networkState === $fcdb6cf3608c4662$var$NetworkState.NETWORK_LOADING) return $fcdb6cf3608c4662$export$e3425b961a6a8509.Loading;
    else if (!videoElement.ended) return videoElement.paused ? $fcdb6cf3608c4662$export$e3425b961a6a8509.Paused : $fcdb6cf3608c4662$export$e3425b961a6a8509.Playing;
    return $fcdb6cf3608c4662$export$e3425b961a6a8509.Ended;
}
var $fcdb6cf3608c4662$export$68ce463a75cf738d = function(_super) {
    $fcdb6cf3608c4662$var$__extends($fcdb6cf3608c4662$export$68ce463a75cf738d, _super);
    function $fcdb6cf3608c4662$export$68ce463a75cf738d(videoElement) {
        var _this = _super.call(this) || this;
        _this.listeners = [];
        _this.videoElement = videoElement;
        if (typeof videoElement === "string") _this.videoElement = document.querySelector(videoElement);
        _this.state = $fcdb6cf3608c4662$var$getInitialState(videoElement);
        _this.setupEventListeners();
        return _this;
    }
    $fcdb6cf3608c4662$export$68ce463a75cf738d.prototype.setupEventListeners = function() {
        this.addListener("loadstart", this.onLoading);
        this.addListener("loadeddata", this.onLoaded);
        this.addListener("playing", this.onPlaying);
        this.addListener("pause", this.onPause);
        this.addListener("seeking", this.onSeeking);
        this.addListener("seeked", this.onSeeked);
        this.addListener("waiting", this.onBuffering);
        this.addListener("timeupdate", this.onTimeUpdate);
        this.addListener("error", this.onError);
        this.addListener("ended", this.onEnded);
    };
    $fcdb6cf3608c4662$export$68ce463a75cf738d.prototype.addListener = function(type, handler) {
        var boundHandler = handler.bind(this);
        this.videoElement.addEventListener(type, boundHandler);
        this.listeners.push({
            type: type,
            handler: boundHandler
        });
    };
    $fcdb6cf3608c4662$export$68ce463a75cf738d.prototype.onLoading = function() {
        if (this.state === $fcdb6cf3608c4662$export$e3425b961a6a8509.Loading) return;
        this.setState($fcdb6cf3608c4662$export$e3425b961a6a8509.Loading);
        this.emit($fcdb6cf3608c4662$export$5013cbcdb4d9878b.Loading);
    };
    $fcdb6cf3608c4662$export$68ce463a75cf738d.prototype.onLoaded = function() {
        if (this.state === $fcdb6cf3608c4662$export$e3425b961a6a8509.Loading) this.emit($fcdb6cf3608c4662$export$5013cbcdb4d9878b.Loaded);
    };
    $fcdb6cf3608c4662$export$68ce463a75cf738d.prototype.onPlaying = function() {
        if (this.state === $fcdb6cf3608c4662$export$e3425b961a6a8509.Ended) this.setState($fcdb6cf3608c4662$export$e3425b961a6a8509.Loading);
        if ([
            $fcdb6cf3608c4662$export$e3425b961a6a8509.Loading,
            $fcdb6cf3608c4662$export$e3425b961a6a8509.Paused
        ].includes(this.state)) {
            if (this.state === $fcdb6cf3608c4662$export$e3425b961a6a8509.Loading) this.emit($fcdb6cf3608c4662$export$5013cbcdb4d9878b.Play);
            if (this.state === $fcdb6cf3608c4662$export$e3425b961a6a8509.Paused) {
                this.lastState = $fcdb6cf3608c4662$export$e3425b961a6a8509.Paused;
                this.emit($fcdb6cf3608c4662$export$5013cbcdb4d9878b.Resume);
            }
            this.setState($fcdb6cf3608c4662$export$e3425b961a6a8509.Playing, true);
        }
        if (this.state === $fcdb6cf3608c4662$export$e3425b961a6a8509.Buffering) this.onBuffered();
    };
    $fcdb6cf3608c4662$export$68ce463a75cf738d.prototype.onPause = function() {
        var _this = this;
        if (this.state !== $fcdb6cf3608c4662$export$e3425b961a6a8509.Playing) return;
        clearTimeout(this.pauseDebounce);
        this.pauseDebounce = window.setTimeout(function() {
            _this.emit($fcdb6cf3608c4662$export$5013cbcdb4d9878b.Pause);
            _this.setState($fcdb6cf3608c4662$export$e3425b961a6a8509.Paused, true);
        }, 200);
    };
    $fcdb6cf3608c4662$export$68ce463a75cf738d.prototype.onSeeking = function() {
        if ([
            $fcdb6cf3608c4662$export$e3425b961a6a8509.Loading,
            $fcdb6cf3608c4662$export$e3425b961a6a8509.Seeking,
            $fcdb6cf3608c4662$export$e3425b961a6a8509.Ended
        ].includes(this.state)) return;
        clearTimeout(this.pauseDebounce);
        this.setState($fcdb6cf3608c4662$export$e3425b961a6a8509.Seeking, true);
        this.emit($fcdb6cf3608c4662$export$5013cbcdb4d9878b.Seeking);
    };
    $fcdb6cf3608c4662$export$68ce463a75cf738d.prototype.onSeeked = function() {
        if (this.state !== $fcdb6cf3608c4662$export$e3425b961a6a8509.Seeking) return;
        this.setState(this.lastState, true);
        this.emit($fcdb6cf3608c4662$export$5013cbcdb4d9878b.Seeked);
    };
    $fcdb6cf3608c4662$export$68ce463a75cf738d.prototype.onBuffering = function() {
        if ([
            $fcdb6cf3608c4662$export$e3425b961a6a8509.Loading,
            $fcdb6cf3608c4662$export$e3425b961a6a8509.Buffering,
            $fcdb6cf3608c4662$export$e3425b961a6a8509.Seeking,
            $fcdb6cf3608c4662$export$e3425b961a6a8509.Ended, 
        ].includes(this.state)) return;
        this.setState($fcdb6cf3608c4662$export$e3425b961a6a8509.Buffering, true);
        this.emit($fcdb6cf3608c4662$export$5013cbcdb4d9878b.Buffering);
    };
    $fcdb6cf3608c4662$export$68ce463a75cf738d.prototype.onBuffered = function() {
        if (this.state !== $fcdb6cf3608c4662$export$e3425b961a6a8509.Buffering) return;
        this.setState(this.lastState, true);
        this.emit($fcdb6cf3608c4662$export$5013cbcdb4d9878b.Buffered);
    };
    $fcdb6cf3608c4662$export$68ce463a75cf738d.prototype.onTimeUpdate = function() {
        if (this.videoElement.seeking || [
            $fcdb6cf3608c4662$export$e3425b961a6a8509.Loading,
            $fcdb6cf3608c4662$export$e3425b961a6a8509.Paused,
            $fcdb6cf3608c4662$export$e3425b961a6a8509.Seeking,
            $fcdb6cf3608c4662$export$e3425b961a6a8509.Buffering,
            $fcdb6cf3608c4662$export$e3425b961a6a8509.Ended, 
        ].includes(this.state)) return;
        this.emit($fcdb6cf3608c4662$export$5013cbcdb4d9878b.TimeUpdate);
    };
    $fcdb6cf3608c4662$export$68ce463a75cf738d.prototype.onEnded = function() {
        clearTimeout(this.pauseDebounce);
        if (this.state === $fcdb6cf3608c4662$export$e3425b961a6a8509.Ended) return;
        this.setState($fcdb6cf3608c4662$export$e3425b961a6a8509.Ended);
        this.emit($fcdb6cf3608c4662$export$5013cbcdb4d9878b.Ended);
    };
    $fcdb6cf3608c4662$export$68ce463a75cf738d.prototype.onError = function() {
        if (this.state === $fcdb6cf3608c4662$export$e3425b961a6a8509.Ended) return;
        this.emit($fcdb6cf3608c4662$export$5013cbcdb4d9878b.Error, this.videoElement.error);
        this.onEnded();
    };
    $fcdb6cf3608c4662$export$68ce463a75cf738d.prototype.getState = function() {
        return this.state;
    };
    $fcdb6cf3608c4662$export$68ce463a75cf738d.prototype.setState = function(state, updateLast) {
        if (updateLast) this.updateLastState(this.state);
        this.state = state;
    };
    $fcdb6cf3608c4662$export$68ce463a75cf738d.prototype.updateLastState = function(state) {
        if (state) this.lastState = state;
        else this.lastState = this.state;
    };
    $fcdb6cf3608c4662$export$68ce463a75cf738d.prototype.destroy = function() {
        var _this = this;
        this.listeners.forEach(function(_a) {
            var type = _a.type, handler = _a.handler;
            _this.videoElement.removeEventListener(type, handler);
        });
        _super.prototype.destroy.call(this);
    };
    return $fcdb6cf3608c4662$export$68ce463a75cf738d;
}($516c8d13080d4552$export$691d3e4b1045a188);




//# sourceMappingURL=index.js.map
